import styled from 'styled-components';

export const StyledQuizBackground = styled('div')`
  position: absolute;
  z-index: -1000;
  opacity: 0;
  visibility: hidden;
`;
